import CategoryLauncherFullWidth from "@/components/CategoryLauncherFullWidth.vue";
import { strippedCta } from "@/helpers/builder-init/index";
import { useBuilderShowIf } from "../composables/builderFieldUtility";
import * as themeColors from "@assets/styles/colors.module.scss";

const { hasValue } = useBuilderShowIf();
const colors = ["Default", ...Object.keys(themeColors)];

export const categoryLauncherFullWidthInit = {
    component: CategoryLauncherFullWidth,
    name: "Category Launcher Full Width",
    canHaveChildren: true,
    models: ["category-landing-content", "content-section", "campaign-content"],
    inputs: [
        {
            name: "headline",
            type: "string"
        },
        {
            name: "togglePadding",
            type: "boolean",
            defaultValue: false
        },
        {
            name: "textBelow",
            type: "boolean",
            defaultValue: false
        },
        {
            name: "use_gradient",
            friendlyName: "Image Gradient",
            type: "boolean"
        },
        {
            name: "gradient_color",
            friendlyName: "Image Gradient Color",
            helperText: "",
            type: "string",
            enum: ['Default', ...colors.slice(1)],
            showIf: hasValue("use_gradient")
        },
        {
            name: "launcherRows",
            type: "list",
            defaultValue: [],
            subFields: [
                {
                    name: "launcherItems",
                    type: "list",
                    defaultValue: [],
                    subFields: [
                        {
                            name: "headline",
                            type: "string"
                        },
                        {
                            name: "image",
                            type: "file",
                            helperText:
                                "Allowed file types - .jpeg, .png, .gif, .svg. Suggested Image sizes are as followed: 4:3 Proportion 1500 px by 1120px.\n 1:1 Proportion 1500px by 1500px.",
                            allowedFileTypes: ["jpeg", "png", "gif", "svg"]
                        },
                        {
                            name: "image_alt",
                            type: "string"
                        },
                        {
                            name: 'cta',
                            type: 'object',
                            subFields: strippedCta(['type', 'url', 'aria_label', 'style']).subFields,
                            defaultValue: {
                                type: 'button'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};
